<template>
  <ModalRoot :closeByClickingOutside="true" @close="$emit('close')" class="modal-dialog--small">
    <div class="modal-dialog__content offer-expired">
      <div class="offer-expired__headline">
        <h1 v-html="data.headline" />
        <hr>
      </div>
      <div class="offer-expired__body">
        <div v-if="data.validationErrors.length" class="offer-expired__validation">
          <div class="offer-expired__subheadline">Błąd walidacji formularza:</div>
          <ul v-for="(error, key) in data.validationErrors" :key="key">
            <li v-for="(status, k) in error.Value" :key="k">{{ status }}</li>
          </ul>
        </div>
        <div class="offer-expired__subheadline">{{ data.subHeadline }}</div>
        <div class="offer-expired__phone">
          <div class="number"><Icon icon="mobile-footer" />
            <a v-if="isMobile" :href="`tel:${data.mobile}`">{{ data.mobile }}</a>
            <span v-else>{{ data.mobile }}</span>
          </div>
        </div>
        <div class="offer-expired__helpline" v-html="data.helpline" />
        <div v-if="fallbackUrl" class="offer-expired__footer">
          <span>lub</span>
          <button @click="redirect">Wróć do strony hotelu <Icon icon="v-right" /></button>
        </div>
      </div>
    </div>
  </ModalRoot>
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'

import Icon from '@/components/Icon'
import ModalRoot from '@/components/ModalRoot'
import MediaDetector from '@/utils/MediaDetector'

@Component({
  mixins: [
    MediaDetector,
  ],
  components: {
    Icon,
    ModalRoot,
  },
  props: {
    data: {
      type: Object,
      required: false,
    },
    fallbackUrl: {
      type: String,
      required: false,
    },
  },
})
export default class OfferExpired extends Vue {
  redirect () {
    window.location.replace(this.fallbackUrl)
  }
}
</script>

<style lang="scss" scoped>
.offer-expired {
  &__headline {
    display: flex;
    flex-direction: column;

    h1 {
      font-family: 'Gotham';
      font-weight: bold;
      font-size: 25px;
      color: #005CA9;
      text-transform: uppercase;
      text-align: center;
      margin: 0 0 10px 0;

      @include media(tablet) {
        font-size: 36px;
      }
    }

    hr {
      background-color: #005CA9;
      width: 54px;
      height: 6px;
      margin: 0 auto;
      border: 0;
    }
  }

  &__body {
    display: grid;
    grid-template-columns: 1fr;
    grid-row-gap: 15px;
    padding: 40px 0 0;
    text-align: center;
  }

  &__subheadline {
    color: #005CA9;
    font-family: 'Georgia';
    font-style: italic;
    font-size: 20px;
    line-height: 1;
  }

  &__phone {
    display: flex;
    flex-direction: column;
    justify-content: center;
    color: #005CA9;

    @include mediaFluid(tablet) {
      flex-direction: row;
    }

    .number {
      display: flex;
      align-items: center;
      font-size: 16px;
      font-weight: bold;
      justify-content: center;

      @include mediaFluid(tablet) {
        justify-content: initial;
      }

      &:first-child {
        margin-bottom: 10px;

        @include mediaFluid(tablet) {
          margin-bottom: 0;
          margin-right: 50px;
        }
      }

      &:last-child {
        font-family: 'Gotham Book';
      }

      a, span {
        text-decoration: none;

        &:last-child {
          margin-top: 4px;
        }
      }
    }

    .figure {
      font-size: 20px;
      margin-right: 5px;
    }
  }

  &__helpline {
    font-family: 'Gotham Book';
    font-size: 13px;
    color: #535353;
    text-transform: uppercase;
  }

  &__footer {
    color: #005CA9;
    font-family: 'Georgia';
    font-style: italic;
    line-height: 1;
    margin-top: 15px;

    span {
      font-size: 20px;
    }

    button {
      display: flex;
      align-items: center;
      justify-content: center;
      border: 0;
      background-color: #E71F6C;
      color: #fff;
      font-family: 'Gotham';
      font-size: 12px;
      font-weight: bold;
      text-transform: uppercase;
      padding: 12px 13px 12px;
      margin: 25px auto 0;
      outline: none;
      cursor: pointer;

      .figure {
        font-size: 20px;
        line-height: 0;
        margin-top: 10px;
        margin-left: 2px;
      }
    }
  }

  &__validation ul {
    padding: 0;
    list-style: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/booking/OfferExpired.vue